//BuildingResult.js



//----------------------------------------------------------------
//----------------------------------------------------------------
//							IMPORT
//----------------------------------------------------------------
//----------------------------------------------------------------
import store from '../store/index.js';
store.getters.config;





//----------------------------------------------------------------
//----------------------------------------------------------------
//							CLASSES
//----------------------------------------------------------------
//----------------------------------------------------------------

//Building Result Class
class BuildingResult {
	// constructor(material, system, actXSpan, actYSpan, load, surfaceArea, clearFloorHeight, structCeilingHeight, weight, cost, carbonData, materialRecyclingContent, materialEndOfLife) {
	constructor(material, system, actXSpan, actYSpan, load, surfaceArea, clearFloorHeight, structCeilingHeight, weight, cost, carbonData) {
		this.material = material;
		this.system = system;
		this.grid = actXSpan.toString() + " m x " +  actYSpan.toString()  + " m";
		this.load = load;
		this.surfaceArea = surfaceArea;
		this.clearFloorHeight = clearFloorHeight;
		this.structCeilingHeight = structCeilingHeight;
		this.weight = weight;
		this.cost = cost;
		this.carbonData = carbonData;
	}
}

//Carbon Data Class
class carbonData {
	constructor(slabs, columns, foundation, core) {
		this.total = slabs + columns + foundation + core;
		this.slabs = slabs;
		this.columns = columns;
		this.foundation = foundation;
		this.core = core;
	}
}


//Material Recycle Content Class
class MaterialRecyclingContent {
	constructor(recyclingSame, newMaterialRenewable, loss) {
		this.recyclingSame = recyclingSame;									//Black
		this.newMaterialRenewable = newMaterialRenewable;					//Light green
		this.loss = loss;													//White
	}
}

//Material End of Life Class
class MaterialEndOfLife {
	constructor(recyclingSame, recyclingHigh, recyclingLow, recyclingUndefined, newMaterialWaste) {
		this.recyclingSame = recyclingSame;									//Black
		this.recyclingHigh = recyclingHigh;									//Dark grey
		this.recyclingLow = recyclingLow;									//Light grey
		this.recyclingUndefined = recyclingUndefined;						//Hatched grey
		this.newMaterialWaste = newMaterialWaste;							//White
	}
}

//Material Content Class
class MaterialContent {
	constructor(reinforcedConcrete, steel, timber) {
		this.reinforcedConcrete = reinforcedConcrete;
		this.steel = steel;
		this.timber = timber;
	}
}



//------------------------------------------------------------------------
//------------------------------------------------------------------------
//                          BUILDING MATERIAL DATA
//------------------------------------------------------------------------
//------------------------------------------------------------------------



//------------------------------------------------------------------------
//LCA values
//------------------------------------------------------------------------

//CO2 values according to IStructE database
//
//CHECK UNITS!!!!!!!!!!!!!!
//------------------------------------------------------------------------
//Steel
// var carbon_reinforcBars = 1.99;             //kgC02e per kg
// var carbon_hotRolledSect = 1.55;
// var carbon_platedSect = 2.46;
// var carbon_galvProfiledSheet = 2.76;

//Concrete
// var carbon_C30_37_CEMI = 342;               //kgCO2e per m3
// var carbon_C30_37_CEMII_A_V = 318;
// var carbon_C30_37_CEMII_B_V = 285.6;
// var carbon_C30_37_CEMIV_B_V = 249.6;
// var carbon_C30_37_CEMII_B_S = 272.4;
// var carbon_C30_37_CEMIII_A = 200.4;
// var carbon_C30_37_CEMIII_B = 145.2;

//Timber 
//Excluding Carbon Storage
// var carbon_softwoodExclCS = 110.46;           //kgCO2e per m3
// var carbon_cltExclCS = 206.96;
// var carbon_glulamExclCS = 225.28;
// var carbon_plywoodExclCS = 367.74;
//Including Carbon Storage
// var carbon_softwoodInclCS = -510.80;           //kgCO2e per m3
// var carbon_cltInclCS = -568.32;
// var carbon_glulamInclCS = -396.00;
// var carbon_plywoodInclCS = -502.20;


//------------------------------------------------------------------------
//Cost values
//------------------------------------------------------------------------

//Steel
// var cost_reinforcBars = 1.55;             //EUR per kg
// var cost_steel_S355 = 2.8;                //EUR per kg
// const platedSectCost;
// var galvProfiledSheetCost = 4;			//EUR per kg

//Concrete
// var cost_C30_37 = 170;                      //EUR per m3
// var cost_formwork = 42;                     //EUR per m2

//Timber 
// const softwoodCost;                            //EUR per m3
// var cost_clt = 600;                           //EUR per m3
// var cost_glulam = 800;
// const plywoodCost;



//------------------------------------------------------------------------
//Densities in kN/m3
//------------------------------------------------------------------------
const gamma_concrete = 25;					
const gamma_steel = 78.1;
const gamma_clt = 3.8;
const gamma_glulam = 3.8;



//------------------------------------------------------------------------
////B+G Reinforcement ratio kg/m3
//------------------------------------------------------------------------
const reinfRatio_slab = 140;
const reinfRatio_col = 300;
const reinfRatio_beam = 180;
const reinfRatio_coreWall = 180;
const reinfRatio_wall = 140;
const reinfRatio_found = 175;
const reinfRatio_compositeSlab = 12;	//kg/m2
const reinfRatio_holribSlab = 12;		//kg/m2




// //------------------------------------------------------------------------
// //Material values from database
// //------------------------------------------------------------------------

// //Carbon
//------------------------------------------------------------------------
var carbon_reinforcBars =		store.state.databaseMaterial.reinforcementBars.carbon;        
var carbon_hotRolledSect =		store.state.databaseMaterial.steel.carbon;
var carbon_galvProfiledSheet =	store.state.databaseMaterial.profileSteelSheet.carbon;
//Concrete
var carbon_C30_37_CEMI =		store.state.databaseMaterial.concrete.carbon;  
//Timber
var carbon_cltExclCS =			store.state.databaseMaterial.timberCLT.carbon;
var carbon_glulamExclCS =		store.state.databaseMaterial.timberGLh.carbon;

//Costs
//------------------------------------------------------------------------
//Steel
var cost_reinforcBars =			store.state.databaseMaterial.reinforcementBars.costs;             
var cost_steel_S355 =			store.state.databaseMaterial.steel.costs;              
var galvProfiledSheetCost =		store.state.databaseMaterial.profileSteelSheet.costs;			
//Concrete
var cost_C30_37 =				store.state.databaseMaterial.concrete.costs;                     
var cost_formwork =				store.state.databaseMaterial.formwork.costs;                     
//Timber                        
var cost_clt =					store.state.databaseMaterial.timberCLT.costs;                      
var cost_glulam =				store.state.databaseMaterial.timberGLh.costs;


function printDataFromBuildingResults() {
	// console.log('carbon_reinforcBars: '			+ carbon_reinforcBars);
	// console.log('carbon_hotRolledSect: '		+ carbon_hotRolledSect);
	// console.log('carbon_galvProfiledSheet: '	+ carbon_galvProfiledSheet);
	// console.log('carbon_C30_37_CEMI: '			+ carbon_C30_37_CEMI);
	// console.log('carbon_cltExclCS: '			+ carbon_cltExclCS);
	// console.log('carbon_glulamExclCS: '			+ carbon_glulamExclCS);
	console.log('cost_reinforcBars: '			+ cost_reinforcBars);
	console.log('cost_steel_S355: '				+ cost_steel_S355);
	console.log('cost_C30_37: '					+ cost_C30_37);
	console.log('cost_formwork: '				+ cost_formwork);
	console.log('cost_clt: '					+ cost_clt);
	console.log('cost_glulam: '					+ cost_glulam);
} 





//------------------------------------------------------------------------
//Recycling values
//------------------------------------------------------------------------

//MRC - Material Recycling Content
function MRC(material, recyclingSame, newMaterialRenewable, loss) {

	this.material = material;

	this.recyclingSame = recyclingSame;									//Black
	this.newMaterialRenewable = newMaterialRenewable;					//Light green
	this.loss = loss;													//White
}

var MRCMaterials = [
	new MRC ( "Timber",    0,     0.975,  0.035 ),
	new MRC ( "Steel",     0.35,  0,      0.65  ),
	new MRC ( "Concrete",  0,     0,      1     )
]



var mrcMaterial = {
	reinforcedConcrete: {
		recyclingSame:			0,
		newMaterialRenewable:	0,
		loss:					1
	},
	steel: {
		recyclingSame:			0.35,
		newMaterialRenewable:	0,
		loss:					0.65
	},
	timber: {
		recyclingSame:			0,
		newMaterialRenewable:	0.975,
		loss:					0.035
	}
}


// //MLP - Material Loop Potential
// function MLP(material, recyclingSame, newMaterialCertifiedRenewable, newMaterialRenewable, newMaterialWaste) {

// this.material = material;

// this.recyclingSame = recyclingSame;										//Black
// this.newMaterialCertifiedRenewable = newMaterialCertifiedRenewable;		//Dark green
// this.newMaterialRenewable = newMaterialRenewable;						//Light green
// this.newMaterialWaste = newMaterialWaste;								//White
// }

// var MLPMaterials = [
// new MLP ( "Timber",    0,     0.975,  0.035,  0    ),
// new MLP ( "Steel",     1,     0,      0,      0    ),
// new MLP ( "Concrete",  0.39,  0,      0,      0.61 )
// ]


//MRC - Material End of Life
function MEoL(material, recyclingSame, recyclingHigh, recyclingLow, recyclingUndefined, loss) {

this.material = material;

this.recyclingSame = recyclingSame;										//Black
this.recyclingHigh = recyclingHigh;										//Dark grey
this.recyclingLow = recyclingLow;										//Light grey
this.recyclingUndefined = recyclingUndefined;							//Hatched grey
this.loss = loss;								//White
}

var MEoLMaterials = [
new MEoL ( "Timber",    0,     0.20,  0.80,  0,     0    ),
new MEoL ( "Steel",     0.99,  0,     0,     0,     0.01 ),
new MEoL ( "Concrete",  0,     0,     0.16,  0.78,  0.06 )
]


var meolMaterial = {
	reinforcedConcrete: {
		recyclingSame:		0,
		recyclingHigh:		0,
		recyclingLow:		0.16,
		recyclingUndefined:	0.78,
		loss:	0.06
	},
	steel: {
		recyclingSame:		0.99,
		recyclingHigh:		0,
		recyclingLow:		0,
		recyclingUndefined:	0,
		loss:	0.01
	},
	timber: {
		recyclingSame:		0,
		recyclingHigh:		0.20,
		recyclingLow:		0.80,
		recyclingUndefined:	0,
		loss:	0			
	}
}




//------------------------------------------------------------------------
//------------------------------------------------------------------------
//                              FUNCTIONS
//------------------------------------------------------------------------
//------------------------------------------------------------------------


//Calculate carbon
//----------------------------------------------------------------------

//Slab
function calculateCarbonForSlab(material, result, structuralSystem) {		//result -> height or custom result class according to slab system

	var embodiedCarbon;

	if(material == "Concrete") {
		// embodiedCarbon = result * carbon_C30_37_CEMI + result * reinfRatio_slab * carbon_reinforcBars;
		embodiedCarbon = result * store.state.databaseMaterial.concrete.carbon + result * reinfRatio_slab * store.state.databaseMaterial.reinforcementBars.carbon;
	}
	else if(material == "Timber") {
		if(structuralSystem == "Plate") {
			// embodiedCarbon = result * carbon_cltExclCS;
			embodiedCarbon = result * store.state.databaseMaterial.timberCLT.carbon;
		}
		else {
			// embodiedCarbon = 0.11 * carbon_cltExclCS + (result - 0.11) * (5/3) * 0.14 * carbon_glulamExclCS;
			embodiedCarbon = 0.11 * store.state.databaseMaterial.timberCLT.carbon + (result - 0.11) * (5/3) * 0.14 * store.state.databaseMaterial.timberGLh.carbon;
		}
	}
	else if(material == "Steel") {
		if(structuralSystem == "Plate") {		//Holrib Slab
			// embodiedCarbon = (result.height - 0.00826) * carbon_C30_37_CEMI + reinfRatio_holribSlab * carbon_reinforcBars + result.profileSheetWeight * carbon_galvProfiledSheet;
			embodiedCarbon = (result.height - 0.00826) * store.state.databaseMaterial.concrete.carbon + reinfRatio_holribSlab * store.state.databaseMaterial.reinforcementBars.carbon + result.profileSheetWeight * store.state.databaseMaterial.profileSteelSheet.carbon;
		}
		else {									//Composite Slab
			// embodiedCarbon = result * carbon_C30_37_CEMI + reinfRatio_compositeSlab * carbon_reinforcBars; 
			embodiedCarbon = result * store.state.databaseMaterial.concrete.carbon + reinfRatio_compositeSlab * store.state.databaseMaterial.reinforcementBars.carbon;
		}
	}
	else if(material == "Hybrid") {
		if(structuralSystem == "Plate") {		//HBV
			// embodiedCarbon = result.heightConcrete * carbon_C30_37_CEMI +  result.heightConcrete * reinfRatio_slab * carbon_reinforcBars + result.heightTimber *  result.widthTimber * carbon_glulamExclCS * ( 1/result.distance );
			embodiedCarbon = result.heightConcrete * store.state.databaseMaterial.concrete.carbon +  result.heightConcrete * reinfRatio_slab * store.state.databaseMaterial.reinforcementBars.carbon + result.heightTimber *  result.widthTimber * store.state.databaseMaterial.timberGLh.carbon * ( 1/result.distance );
		}
		else {									//CLT
			// embodiedCarbon = result * carbon_cltExclCS;
			embodiedCarbon = result * store.state.databaseMaterial.timberCLT.carbon;
		}
	}

	return embodiedCarbon;
}

//Beam
function calculateCarbonForBeam(material, structSystem, result) {

	var embodiedCarbon;
	var area = result.area;

	if(material == "Concrete") {
		// embodiedCarbon = area * carbon_C30_37_CEMI + area * reinfRatio_beam * carbon_reinforcBars;
		embodiedCarbon = area * store.state.databaseMaterial.concrete.carbon + area * reinfRatio_beam * store.state.databaseMaterial.reinforcementBars.carbon;
	}
	else if(material == "Timber") {
		// embodiedCarbon = area * carbon_glulamExclCS;
		embodiedCarbon = area * store.state.databaseMaterial.timberGLh.carbon;
	}
	else if(material == "Steel") {
		// embodiedCarbon = area * 7810 * carbon_hotRolledSect;
		embodiedCarbon = area * 7810 * store.state.databaseMaterial.steel.carbon;
	}
	else if(material == "Hybrid") {
		if(structSystem == "Plate") {
			// embodiedCarbon = area * carbon_glulamExclCS;
			embodiedCarbon = area * store.state.databaseMaterial.timberGLh.carbon;
		}
		else if(structSystem == "Beam") {
			// embodiedCarbon = area * 7810 * carbon_hotRolledSect;
			embodiedCarbon = area * 7810 * store.state.databaseMaterial.steel.carbon;
		}
	}

	return embodiedCarbon;                              //carbon per m
}

//Column
function calculateCarbonForColumn(material, structSystem, result) {

	var embodiedCarbon;
	var area = result.area;

	if(material == "Concrete") {
		// embodiedCarbon = area * carbon_C30_37_CEMI + area * reinfRatio_col * carbon_reinforcBars;
		embodiedCarbon = area * store.state.databaseMaterial.concrete.carbon + area * reinfRatio_col * store.state.databaseMaterial.reinforcementBars.carbon;
	}
	else if(material == "Timber") {
		// embodiedCarbon = area * carbon_glulamExclCS;
		embodiedCarbon = area * store.state.databaseMaterial.timberGLh.carbon;
	}
	else if(material == "Steel") {
		// embodiedCarbon = area * 7810 * carbon_hotRolledSect;
		embodiedCarbon = area * 7810 * store.state.databaseMaterial.steel.carbon;
	}
	else if(material == "Hybrid") {
		if(structSystem == "Plate") {
			// embodiedCarbon = area * carbon_glulamExclCS;
			embodiedCarbon = area * store.state.databaseMaterial.timberGLh.carbon;
		}
		else {
			// embodiedCarbon = area * 7810 * carbon_hotRolledSect;
			embodiedCarbon = area * 7810 * store.state.databaseMaterial.steel.carbon;
		}
	}

	return embodiedCarbon;                              //carbon per m
}

//Core
function calculateCarbonForCore(circumference, buildingHeight, result) {

	var embodiedCarbon;
	var volume = circumference * buildingHeight * result;
	// embodiedCarbon = volume * carbon_C30_37_CEMI + volume * reinfRatio_coreWall * carbon_reinforcBars;
	embodiedCarbon = volume * store.state.databaseMaterial.concrete.carbon + volume * reinfRatio_coreWall * store.state.databaseMaterial.reinforcementBars.carbon;

	return embodiedCarbon;
}

//Ground Slab
function calculateCarbonForGroundSlab(result) {

	var embodiedCarbon;
	// embodiedCarbon = result * carbon_C30_37_CEMI + result * reinfRatio_found * carbon_reinforcBars;
	embodiedCarbon = result * store.state.databaseMaterial.concrete.carbon + result * reinfRatio_found * store.state.databaseMaterial.reinforcementBars.carbon;

	return embodiedCarbon;							//Return per m2
}



//Calculate cost
//----------------------------------------------------------------------

//Slab
function calculateCostsForSlab(material, result, structuralSystem) {

	var cost;
	if(material == "Concrete") {
		// cost = result * cost_C30_37 + cost_formwork + result * reinfRatio_slab * cost_reinforcBars;
		cost = result * store.state.databaseMaterial.concrete.costs + store.state.databaseMaterial.formwork.costs + result * reinfRatio_slab * store.state.databaseMaterial.reinforcementBars.costs;
	}
	else if(material == "Timber") {
		if(structuralSystem == "Plate") {
			// cost = result * cost_clt;
			cost = result * store.state.databaseMaterial.timberCLT.costs;
		}
		else {
			// cost = 0.11 * cost_clt + (result - 0.11) * (5/3) * 0.14 * cost_glulam ;
			cost = 0.11 * store.state.databaseMaterial.timberCLT.costs + (result - 0.11) * (5/3) * 0.14 * store.state.databaseMaterial.timberGLh.costs ;
		}
	}
	else if(material == "Steel") {
		if(structuralSystem == "Plate") {
			// cost = (result.height - 0.00826) * cost_C30_37 + reinfRatio_holribSlab * cost_reinforcBars + result.profileSheetWeight * galvProfiledSheetCost;  //0.00826 -> cavity by profile sheet
			cost = (result.height - 0.00826) * store.state.databaseMaterial.concrete.costs + reinfRatio_holribSlab * store.state.databaseMaterial.reinforcementBars.costs + result.profileSheetWeight * store.state.databaseMaterial.profileSteelSheet.costs;  //0.00826 -> cavity by profile sheet
		}
		else {
			// cost = result * cost_C30_37 + cost_formwork + reinfRatio_compositeSlab * cost_reinforcBars;
			cost = result * store.state.databaseMaterial.concrete.costs + store.state.databaseMaterial.formwork.costs + reinfRatio_compositeSlab * store.state.databaseMaterial.reinforcementBars.costs;
		}
	}
	else if(material == "Hybrid") {
		if(structuralSystem == "Plate") {
			// cost = result.heightConcrete * cost_C30_37 +  result.heightConcrete * reinfRatio_slab * cost_reinforcBars + cost_formwork + result.heightTimber *  result.widthTimber * cost_glulam * ( 1/result.distance );
			cost = result.heightConcrete * store.state.databaseMaterial.concrete.costs +  result.heightConcrete * reinfRatio_slab * store.state.databaseMaterial.reinforcementBars.costs + store.state.databaseMaterial.formwork.costs + result.heightTimber *  result.widthTimber * store.state.databaseMaterial.timberGLh.costs * ( 1/result.distance );
		}
		else {
			// cost = cost = result * cost_clt;
			cost = cost = result * store.state.databaseMaterial.timberCLT.costs;
		}
	}

	return cost;                    //Cost per m2
}

//Beam
function calculateCostsForBeam(material, structSystem, result) {

	var cost;
	var area = result.area;

	if(material == "Concrete") {
		// cost = area * cost_C30_37 + area * reinfRatio_beam * cost_reinforcBars;
		cost = area * store.state.databaseMaterial.concrete.costs + area * reinfRatio_beam * store.state.databaseMaterial.reinforcementBars.costs;
	}
	else if(material == "Timber") {
		// cost = area * cost_glulam;
		cost = area * store.state.databaseMaterial.timberGLh.costs;
	}
	else if(material == "Steel") {
		// cost = area * 7810 * cost_steel_S355;
		cost = area * 7810 * store.state.databaseMaterial.steel.costs;
	}
	else if(material == "Hybrid") {
		if(structSystem == "Plate") {
			// cost = area * cost_glulam;
			cost = area * store.state.databaseMaterial.timberGLh.costs;
		}
		else if(structSystem == "Beam") {
			// cost = area * 7810 * cost_steel_S355;
			cost = area * 7810 * store.state.databaseMaterial.steel.costs;
		}
	}

	return cost;                              //cost per m
}



//Column
function calculateCostsForColumn(material, structSystem, result) {

	var cost;
	var area = result.area;

	if(material == "Concrete") {
		// cost = area * cost_C30_37 + area * reinfRatio_col * cost_reinforcBars;
		cost = area * store.state.databaseMaterial.concrete.costs + area * reinfRatio_col * store.state.databaseMaterial.reinforcementBars.costs;
	}
	else if(material == "Timber") {
		// cost = area * cost_glulam;
		cost = area * store.state.databaseMaterial.timberGLh.costs;
	}
	else if(material == "Steel") {
		// cost = area * 7810 * cost_steel_S355;
		cost = area * 7810 * store.state.databaseMaterial.steel.costs;
	}
	else if(material == "Hybrid") {
		if(structSystem == "Plate") {
			// cost = area * cost_glulam;
			cost = area * store.state.databaseMaterial.timberGLh.costs;
		}
		else {
			// cost = area * 7810 * cost_steel_S355;
			cost = area * 7810 * store.state.databaseMaterial.steel.costs;
		}
	}

	return cost;                              //cost per m
}

//Core
function calculateCostsForCore(circumference, buildingHeight, result) {

	var cost;
	var volume = circumference * buildingHeight * result;

	// cost = volume * cost_C30_37 + volume * reinfRatio_coreWall * cost_reinforcBars;
	cost = volume * store.state.databaseMaterial.concrete.costs + volume * reinfRatio_coreWall * store.state.databaseMaterial.reinforcementBars.costs;

	return cost;
}

//Ground Slab
function calculateCostsForGroundSlab(result) {

	var cost;

	// cost = result * cost_C30_37 + result * reinfRatio_found * cost_reinforcBars;
	cost = result * store.state.databaseMaterial.concrete.costs + result * reinfRatio_found * store.state.databaseMaterial.reinforcementBars.costs;

	return cost;							//Return per m2
}



//Calculate weight
//----------------------------------------------------------------------

//Slab
function calculateWeightForSlab(material, result, structuralSystem) {

	var weight;
	if(material == "Concrete") {
		weight = result * gamma_concrete;
	}
	else if(material == "Timber") {
		if(structuralSystem == "Plate") {
			weight = result * gamma_clt;
		}
		else {
			weight = 0.11 * gamma_clt + (result - 0.11) * (5/3) * 0.14 * gamma_glulam;
		}
	}
	else if(material == "Steel") {
		if(structuralSystem == "Plate") {
			weight = (result.height - 0.00826) * gamma_concrete + result.profileSheetWeight / 100;
		}
		else {
			weight = result * gamma_concrete;
		}
	}
	else if(material == "Hybrid") {
		if(structuralSystem == "Plate") {
			weight = result.heightConcrete * gamma_concrete + result.heightTimber *  result.widthTimber * gamma_glulam * ( 1/result.distance );
		}
		else {
			weight = result * gamma_clt;
		}
	}

	return weight;												//kN/m2
}

//Beam
function calculateWeightForBeam(material,structSystem, result) {

	var weight;
	var area = result.area;

	if(material == "Concrete") {
		weight = area * gamma_concrete;
	}
	else if(material == "Timber") {
		weight = area * gamma_glulam;
	}
	else if(material == "Steel") {
		weight = area * gamma_steel;
	}
	else if(material == "Hybrid") {
		if(structSystem == "Plate") {
			weight = area * gamma_glulam;
		}
		else if(structSystem == "Beam") {
			weight = area * gamma_steel;
		}
	}

	return weight;                              //return weight in kN/m
}


//Column
function calculateWeightForColumn(material, structSystem, result) {

	var weight;
	var area = result.area;

	if(material == "Concrete") {
		weight = area * gamma_concrete;
	}
	else if(material == "Timber") {
		weight = area * gamma_glulam;
	}
	else if(material == "Steel") {
		weight = area * gamma_steel;
	}
	else if(material == "Hybrid") {
		if(structSystem == "Plate") {
			weight = area * gamma_glulam;
		}
		else {
			weight = area * gamma_steel;
		}
	}

	return weight;                              //weight per m
}

//Core
function calculateWeightForCore(circumference, buildingHeight, result) {

	var weight;
	var volume = circumference * buildingHeight * result;
	weight = volume * gamma_concrete;

	return weight;
}

//Ground Slab
function calculateWeightForGroundSlab(result) {

	var weight;
	weight = result * gamma_concrete;

	return weight;							//Return per m2
}



//Calculate material content
//----------------------------------------------------------------------
function calculateMaterialContent(material, structSystem, slabs, columns, beams, coreVolume, groundSlabVolume, surfaceAreaPerStory) {

	var  materialContent = new MaterialContent(0, 0, 0);

	//Single total volumes
	var totalSlabVolume = 0;
	var totalColumnVolume = 0;
	var totalBeamVolume = 0;

	// console.log('surfaceAreaPerStory');
	// console.log(surfaceAreaPerStory);

	// console.log('coreVolume from calculateMaterialContent');
	// console.log(coreVolume);

	// console.log('groundSlabVolume from calculateMaterialContent');
	// console.log(groundSlabVolume);

	//Concrete
	//--------------------------------------------------------------------------------------------------------------------
	if(material == "Concrete") {
		//Slab
		for (let i = 0; i < slabs.length; i++) {
			var slabVolumeConcrete = slabs[i].height * surfaceAreaPerStory;
			totalSlabVolume = totalSlabVolume + slabVolumeConcrete;
		}
		//Columns
		for (let i = 0; i < columns.length; i++) {
			var columnVolume = columns[i].crossSection.area * columns[i].distance();
			totalColumnVolume = totalColumnVolume + columnVolume;
		}
		//Beams
		if(structSystem == "Beam") {
			for (let i = 0; i < beams.length; i++) {
				var beamVolume = beams[i].crossSection.area * beams[i].distance();
				totalBeamVolume = totalBeamVolume + beamVolume;
			}
		}
		else {
			totalBeamVolume = 0;
		}

		//Adding
		materialContent.reinforcedConcrete = totalSlabVolume + totalColumnVolume + totalBeamVolume;
	}

	//Timber
	//--------------------------------------------------------------------------------------------------------------------
	else if(material == "Timber") {
		//Slab
		if(structSystem == "Plate") {
			for (let i = 0; i < slabs.length; i++) {
				var slabVolumeTimberPlate = slabs[i].height * surfaceAreaPerStory;
				totalSlabVolume = totalSlabVolume + slabVolumeTimberPlate;
			}
		}
		else if(structSystem == "Beam") {
			for (let i = 0; i < slabs.length; i++) {
				var slabVolumeTimberBeam = ( 0.11 + (slabs[i].height - 0.11) * (5/3) * 0.14 ) * surfaceAreaPerStory;
				totalSlabVolume = totalSlabVolume + slabVolumeTimberBeam;
			}
		}
		//Columns
		for (let i = 0; i < columns.length; i++) {
			var columnVolumeTimber = columns[i].crossSection.area * columns[i].distance();
			totalColumnVolume = totalColumnVolume + columnVolumeTimber;
		}
		//Beams
		for (let i = 0; i < beams.length; i++) {
			var beamVolumeTimber = beams[i].crossSection.area * beams[i].distance();
			totalBeamVolume = totalBeamVolume + beamVolumeTimber;
		}

		//Adding
		materialContent.timber = totalSlabVolume + totalColumnVolume + totalBeamVolume;
	}

	//Steel
	//--------------------------------------------------------------------------------------------------------------------
	else if(material == "Steel") {
		//Slab
		var profileSheetVolume = 0;
		if(structSystem == "Plate") {
			for (let i = 0; i < slabs.length; i++) {
				var slabVolumeSteelPlate = slabs[i].height.height * surfaceAreaPerStory;
				totalSlabVolume = totalSlabVolume + slabVolumeSteelPlate;
				profileSheetVolume = surfaceAreaPerStory * ( (slabs[i].height.profileSheetWeight / 100) / gamma_steel);
			}
		}
		else if(structSystem == "Beam") {
			for (let i = 0; i < slabs.length; i++) {
				var slabVolumeSteelBeam = slabs[i].height * surfaceAreaPerStory;
				totalSlabVolume = totalSlabVolume + slabVolumeSteelBeam;
			}
		}
		//Columns
		for (let i = 0; i < columns.length; i++) {
			var columnVolumeSteel = columns[i].crossSection.area * columns[i].distance();
			totalColumnVolume = totalColumnVolume + columnVolumeSteel;
		}
		//Beams
		for (let i = 0; i < beams.length; i++) {
			var beamVolumeSteel = beams[i].crossSection.area * beams[i].distance();
			totalColumnVolume = totalColumnVolume + beamVolumeSteel;
		}

		//Adding
		materialContent.steel =  	totalColumnVolume + totalBeamVolume + profileSheetVolume;
		materialContent.concrete =  totalSlabVolume;
	}

	//Hybrid
	//--------------------------------------------------------------------------------------------------------------------
	else if(material == "Hybrid") {
		if(structSystem == "Plate") {
			//Slab
			var slabVolumeHybridPlateConcrete = 0;
			var slabVolumeHybridPlateTimber = 0;
			for (let i = 0; i < slabs.length; i++) {
				var concreteVolume = slabs[i].height.heightConcrete * surfaceAreaPerStory;
				slabVolumeHybridPlateConcrete = slabVolumeHybridPlateConcrete + concreteVolume;
				var timberVolume = ( slabs[i].height.heightTimber *  slabs[i].height.widthTimber * ( 1/slabs[i].height.distance ) ) * surfaceAreaPerStory;
				slabVolumeHybridPlateTimber = slabVolumeHybridPlateTimber + timberVolume;
			}
			//Columns
			for (let i = 0; i < columns.length; i++) {
				var columnVolumeHybridPlate = columns[i].crossSection.area * columns[i].distance();
				totalColumnVolume = totalColumnVolume + columnVolumeHybridPlate;
			}
			//Beams
			for (let i = 0; i < beams.length; i++) {
				var beamVolumeHybridBeam = beams[i].crossSection.area * beams[i].distance();
				totalBeamVolume = totalBeamVolume + beamVolumeHybridBeam;
			}

			//Adding
			materialContent.timber =  	totalColumnVolume + totalBeamVolume + slabVolumeHybridPlateTimber;
			materialContent.concrete = 	slabVolumeHybridPlateConcrete;
		}
		else if(structSystem == "Beam") {
			//Slab
			for (let i = 0; i < slabs.length; i++) {
				var slabVolumeHybridBeam = slabs[i].height * surfaceAreaPerStory;
				totalSlabVolume = totalSlabVolume + slabVolumeHybridBeam;
			}
			//Columns
			for (let i = 0; i < columns.length; i++) {
				var columnVolumeHybridBeams = columns[i].crossSection.area * columns[i].distance();
				totalColumnVolume = totalColumnVolume + columnVolumeHybridBeams;
			}
			//Beams
			for (let i = 0; i < beams.length; i++) {
				var beamVolumeHybridBeams = beams[i].crossSection.area * beams[i].distance();
				totalColumnVolume = totalColumnVolume + beamVolumeHybridBeams;
			}

			//Adding
			materialContent.steel =  	totalColumnVolume + totalBeamVolume;
			materialContent.timber = 	totalSlabVolume;
		}
	}


	//Adding slab and cores
	materialContent.reinforcedConcrete = materialContent.reinforcedConcrete  + ( coreVolume + groundSlabVolume );

	// console.log('materialContent');
	// console.log(materialContent);

	return materialContent;
}



//Calculate recycle content
//----------------------------------------------------------------------

//Main
function calculateMaterialRecyclingContent(materialContent) {

	var materialRecyclingContent = new MaterialRecyclingContent(0, 0, 0);

	//Recycling same
	materialRecyclingContent.recyclingSame = 		materialContent.reinforcedConcrete * mrcMaterial.reinforcedConcrete.recyclingSame + 
													materialContent.steel * mrcMaterial.steel.recyclingSame + 
													materialContent.timber * mrcMaterial.timber.recyclingSame;
	//New Material Renewable
	materialRecyclingContent.newMaterialRenewable = materialContent.reinforcedConcrete * mrcMaterial.reinforcedConcrete.newMaterialRenewable + 
													materialContent.steel * mrcMaterial.steel.newMaterialRenewable + 
													materialContent.timber * mrcMaterial.timber.newMaterialRenewable;
	//Loss
	materialRecyclingContent.loss = 				materialContent.reinforcedConcrete * mrcMaterial.reinforcedConcrete.loss + 
													materialContent.steel * mrcMaterial.steel.loss + 
													materialContent.timber * mrcMaterial.timber.loss;

	return materialRecyclingContent;
}



function calculateMaterialEndOfLife(materialContent) {

	var materialEndOfLife = new MaterialEndOfLife(0, 0, 0, 0, 0);

	//Recycling same
	materialEndOfLife.recyclingSame = 			materialContent.reinforcedConcrete * meolMaterial.reinforcedConcrete.recyclingSame + 
												materialContent.steel * meolMaterial.steel.recyclingSame + 
												materialContent.timber * meolMaterial.timber.recyclingSame;
	//Recycling high
	materialEndOfLife.recyclingHigh = 			materialContent.reinforcedConcrete * meolMaterial.reinforcedConcrete.recyclingHigh + 
												materialContent.steel * meolMaterial.steel.recyclingHigh + 
												materialContent.timber * meolMaterial.timber.recyclingHigh;
	//Recycling low
	materialEndOfLife.recyclingLow = 			materialContent.reinforcedConcrete * meolMaterial.reinforcedConcrete.recyclingLow + 
												materialContent.steel * meolMaterial.steel.recyclingLow + 
												materialContent.timber * meolMaterial.timber.recyclingLow;
	//Recycling undefined
	materialEndOfLife.recyclingUndefined = 		materialContent.reinforcedConcrete * meolMaterial.reinforcedConcrete.recyclingUndefined + 
												materialContent.steel * meolMaterial.steel.recyclingUndefined + 
												materialContent.timber * meolMaterial.timber.recyclingUndefined;
	//Recycling undefined
	materialEndOfLife.loss = 					materialContent.reinforcedConcrete * meolMaterial.reinforcedConcrete.loss + 
												materialContent.steel * meolMaterial.steel.loss + 
												materialContent.timber * meolMaterial.timber.loss;

	return materialEndOfLife;
}


//Additional functions
//----------------------------------------------------------------------

function calculateSlabDeadLoad(material, height) {

	var deadLoadSlab = 0;                                   //kN/m2

	if (material == "Concrete") {
		deadLoadSlab = gamma_concrete * height;
	} 
	else if (material == "Timber") {
		deadLoadSlab = gamma_clt * height;
	}
	else if (material == "Concrete") {
		deadLoadSlab = gamma_concrete * height;
	}
	else {
		console.log("Error: No material selected!");
	}

	return deadLoadSlab; 
}


function getStructuralSystem(material, structSystem) {

	var system; 

	//Steel
	if(material == 'Steel') {
		if(structSystem == 'Plate') {
			system = "Holorib Slab";
		}
		else if(structSystem == 'Beam') {
			system = "Composite Beams";
		}
	}
	//Concrete
	else if(material == 'Concrete') {
		if(structSystem == 'Plate') {
			system = "Flat Slab";
		}
		else if(structSystem == 'Beam') {
			system = "T-Beams";
		}
	}
	//Timber
	else if(material == 'Timber') {
		if(structSystem == 'Plate') {
			system = "CLT Slab on Glulam";
		}
		else if(structSystem == 'Beam') {
			system = "Ribbed Slab";
		}
	}
	//Hybrid
	else if(material == 'Hybrid') {
		if(structSystem == 'Plate') {
			system = "HBV Slab";
		}
		else if(structSystem == 'Beam') {
			system = "CLT on Steel";
		}
	}

	return system;
}





//------------------------------------------------------------------------
//Export
//------------------------------------------------------------------------

export { 	BuildingResult,																																			//Classes
			calculateCarbonForSlab,		calculateCarbonForBeam,				calculateCarbonForColumn,	calculateCarbonForCore,	calculateCarbonForGroundSlab,		//Carbon calculation
			calculateCostsForSlab,		calculateCostsForBeam,				calculateCostsForColumn,	calculateCostsForCore,	calculateCostsForGroundSlab,		//Costs calculation
			calculateWeightForSlab,		calculateWeightForBeam,				calculateWeightForColumn,	calculateWeightForCore,	calculateWeightForGroundSlab,		//Weight calculation
			calculateMaterialContent, 	calculateMaterialRecyclingContent, 	calculateMaterialEndOfLife,																//Material Recycling Content calculation
			getStructuralSystem,		calculateSlabDeadLoad,				printDataFromBuildingResults																								//Additional functions
		}





